import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import Spinner from '../Spinner'
import { translatePartnerType } from '../../utils/translator'

const ReceiptModal = (props) => {

    const { isOpen, closeModal, onClick, onClickDetailed, pendingApiCall } = props

    const [partnerType, setPartnerType] = useState('SUPPLIER')
    const [currency, setCurrency] = useState('TRY')

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                >
                                    Ekstre
                                </Dialog.Title>
                                <label className='block mb-2'>İş Ortağı</label>
                                <div className='flex gap-x-5 mb-5'>
                                    {
                                        ['SUPPLIER', 'OUTSOURCER', 'CUSTOMER'].map((type, index) => (
                                            <label
                                                className={`${partnerType === type ? 'bg-blue-700 text-white' : 'bg-zinc-100'} px-3 py-2 rounded-md shadow-md cursor-pointer hover:bg-blue-700 hover:text-white duration-150`}
                                                onClick={() => setPartnerType(type)}
                                            >
                                                {translatePartnerType(type)}
                                            </label>
                                        ))
                                    }
                                </div>
                                <label className='block mb-2'>Kur</label>
                                <div className='flex gap-x-5 mb-10'>
                                    {
                                        ['TRY', 'USD', 'EUR'].map((c, index) => (
                                            <label
                                                className={`${currency === c ? 'bg-blue-700 text-white' : 'bg-zinc-100'} px-3 py-2 rounded-md shadow-md cursor-pointer hover:bg-blue-700 hover:text-white duration-150`}
                                                onClick={() => setCurrency(c)}
                                            >
                                                {c}
                                            </label>
                                        ))
                                    }
                                </div>
                                <div className="mt-4 flex justify-between">
                                    <button
                                        type="button"
                                        className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200"
                                        onClick={() => onClick(partnerType, currency)}
                                        disabled={pendingApiCall}
                                    >
                                        Oluştur
                                        {pendingApiCall && <Spinner />}
                                    </button>
                                    <button
                                        type="button"
                                        className="outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                        onClick={closeModal}
                                    >
                                        İptal
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default ReceiptModal